import { Link } from 'react-router-dom';
import { useAppointments } from '@/hooks/use-catalog';
import { PageHeader } from '@/components/layout/app-shell';
import { AppointmentCard } from '@/components/appointment-card';
import { EmptyState, ErrorState, Skeleton } from '@barber/ui';
import { CalendarDays } from 'lucide-react';

/**
 * Meus horários.
 *
 * Só o que está por vir. O que já passou fica no histórico — misturar os dois
 * numa lista só faria o cliente rolar por cortes de meses atrás para achar o de
 * sábado.
 */
export function AppointmentsPage() {
  const proximos = useAppointments('proximos');

  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        title="Meus horários"
        description="O que está marcado daqui para a frente."
        action={
          <Link
            to="/agendar"
            className="tap-target inline-flex items-center rounded-xl bg-brand px-4 py-2 text-sm font-semibold text-brand-fg"
          >
            Agendar
          </Link>
        }
      />

      {proximos.isPending && (
        <div className="flex flex-col gap-3">
          <Skeleton className="h-24" />
          <Skeleton className="h-24" />
        </div>
      )}

      {proximos.isError && (
        <ErrorState
          description="Não conseguimos carregar seus horários."
          onRetry={() => void proximos.refetch()}
        />
      )}

      {proximos.isSuccess && proximos.data.length === 0 && (
        <EmptyState
          icon={CalendarDays}
          title="Nada marcado por enquanto"
          description="Quando você agendar, o horário aparece aqui com o botão de cancelar e remarcar."
          action={
            <Link
              to="/agendar"
              className="tap-target inline-flex items-center rounded-xl bg-brand px-5 py-3 text-sm font-semibold text-brand-fg"
            >
              Escolher um horário
            </Link>
          }
        />
      )}

      {proximos.data && proximos.data.length > 0 && (
        <ul className="flex flex-col gap-3">
          {proximos.data.map((appointment) => (
            <AppointmentCard key={appointment.id} appointment={appointment} />
          ))}
        </ul>
      )}
    </div>
  );
}
